import { contextFactory, ModalControlResponse } from '@frontend/design-system';
import { FilterValues } from '../types';

interface CallIntelFiltersContextConfig {
  // `filterValues` contains the sanitized filters (Batch-1 pending locations are removed)
  // to be used by APIs and active dashboard components.
  filterValues: FilterValues;
  // `allSelectedLocationIds` contains the raw unfiltered selection (including Batch-1 pending locations)
  // to be used specifically by UI selection controls (such as the location dropdown selector).
  allSelectedLocationIds: string[];
  errors: Partial<Record<keyof FilterValues, string | boolean>>;
  isTrayOpen: boolean;
  filtersModified: Partial<Record<keyof FilterValues, boolean>>;
  isLoading: boolean;
  hasAnyFilterModified: boolean;
  autoResetFilters: Partial<Record<keyof FilterValues, boolean>>;
  updateFilterValues: (filters: FilterValues) => void;
  updateFilterModified: (modifiedFilters: Partial<Record<keyof FilterValues, boolean>>) => void;
  updateErrors: (errors: Partial<Record<keyof FilterValues, string | boolean>>) => void;
  setAutoResetFilters: (autoResetFilters: Partial<Record<keyof FilterValues, boolean>>) => void;
  trayControlProps: ModalControlResponse;
  resetFilters: () => void;
  setFilterHintText: (hintText: string) => void;
}

export const [CallIntelFiltersContext, useCallIntelFiltersContext] = contextFactory<CallIntelFiltersContextConfig>(
  'useCallIntelFiltersContext hook must be used within a CallIntelFiltersProvider'
);
